import { createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-54d61510")

_pushScopeId("data-v-54d61510")
const _hoisted_1 = {
  class: "moreMenu absoluteMenu",
  ref: "moreMenu"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "+", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Add child ")
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "delete", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "content_copy", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Copy ")
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "add_to_photos", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Duplicate ")
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
const _hoisted_14 = { class: "material-icons" }
const _hoisted_15 = { class: "itemName row" }
const _hoisted_16 = { class: "material-icons" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "material-icons dragIndicator" }, "drag_indicator", -1)
const _hoisted_18 = {
  key: 0,
  class: "subFolder"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_drag_zone = _resolveComponent("drag-zone")
  const _component_component_list = _resolveComponent("component-list")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.optElem)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (
            _ctx.optElem.isGroup() &&
              (_ctx.optElem.itemLimit === undefined ||
                _ctx.optElem.itemLimit > _ctx.optElem.getItems().length)
          )
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode("div", {
                    class: "entry",
                    onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.addChildOpt(...args)), ["stop"]))
                  }, [
                    _hoisted_2,
                    _hoisted_3
                  ]),
                  _hoisted_4
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: "entry",
              onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.deleteOpt()), ["stop"]))
            }, [
              _hoisted_5,
              _hoisted_6
            ]),
            _hoisted_7,
            _createVNode("div", {
              class: "entry",
              onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.copyOpt()), ["stop"]))
            }, [
              _hoisted_8,
              _hoisted_9
            ]),
            _hoisted_10,
            (_ctx.hasCapacity)
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createVNode("div", {
                    class: "entry",
                    onClick: _cache[4] || (_cache[4] = _withModifiers($event => (_ctx.duplicateOpt()), ["stop"]))
                  }, [
                    _hoisted_11,
                    _hoisted_12
                  ]),
                  _hoisted_13
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("", true),
            (_ctx.optElem.hideable)
              ? (_openBlock(), _createBlock("div", {
                  key: 2,
                  class: "entry",
                  onClick: _cache[5] || (_cache[5] = _withModifiers($event => (_ctx.visibilityOpt()), ["stop"]))
                }, [
                  _createVNode("span", _hoisted_14, _toDisplayString(_ctx.invisibleIDs.indexOf(_ctx.optElem.id) != -1
              ? "visibility"
              : "visibility_off"), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.invisibleIDs.indexOf(_ctx.optElem.id) != -1 ? "Show" : "Hide"), 1 /* TEXT */)
                ]))
              : _createCommentVNode("", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("", true)
    ], 512),
    _createVNode("div", null, [
      (_ctx.activeIndex != 0 && _ctx.hasCapacity)
        ? (_openBlock(), _createBlock(_component_drag_zone, {
            key: 0,
            dragIndication: !!_ctx.treeState.dragElement,
            onDroped: _cache[6] || (_cache[6] = $event => (_ctx.dragDrop(0)))
          }, null, 8, ["dragIndication"]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.components, (elem, index) => {
        return (_openBlock(), _createBlock("div", { key: index }, [
          _createVNode("div", {
            class: ["item", 
            (_ctx.modelValue == elem ? 'active ' : '') +
              (elem.id && _ctx.invisibleIDs.indexOf(elem.id) != -1
                ? 'invisible '
                : '') +
              (_ctx.itemClasses[index] || '')
          ],
            onMousedown: _withModifiers($event => (
            _ctx.$emit('update:modelValue', {
              value: _ctx.modelValue == elem ? null : elem,
              event: $event
            })
          ), ["stop"]),
            draggable: "true",
            ondragstart: "event.dataTransfer.setData('text/plain',null)",
            onDragstart: _withModifiers(ev => _ctx.dragStart(ev.target, elem, index), ["self"]),
            onDragend: _cache[12] || (_cache[12] = _withModifiers(ev => _ctx.dragEnd(ev.target), ["self"])),
            onDragover: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createVNode("div", _hoisted_15, [
              (elem.isGroup())
                ? (_openBlock(), _createBlock("span", {
                    key: 0,
                    class: "material-icons expandBtn",
                    onClick: _withModifiers($event => (elem.expanded = !elem.expanded), ["stop"])
                  }, _toDisplayString(elem.expanded ? "keyboard_arrow_down" : "keyboard_arrow_right"), 9, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode("span", _hoisted_16, _toDisplayString(elem.icon), 1),
              _createTextVNode(_toDisplayString(elem.name) + " ", 1 /* TEXT */),
              _hoisted_17,
              _createVNode("span", {
                class: "material-icons moreMenuBtn",
                onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                onClick: _withModifiers(ev => _ctx.openMenu(elem, ev), ["stop"])
              }, "more_vert", 40, ["onClick"])
            ]),
            (elem.isGroup() && elem.expanded)
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _createVNode(_component_component_list, {
                    components: elem.getItems(),
                    modelValue: _ctx.modelValue,
                    treeState: _ctx.treeState,
                    itemLimit: elem.itemLimit,
                    itemClasses: elem.itemClasses,
                    onDeleted: _cache[8] || (_cache[8] = $event => (_ctx.$emit('deleted', $event))),
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = val => _ctx.$emit('update:modelValue', val)),
                    onCopy: _cache[10] || (_cache[10] = val => _ctx.$emit('copy', val)),
                    onAddChild: _cache[11] || (_cache[11] = val => _ctx.$emit('add-child', val))
                  }, null, 8, ["components", "modelValue", "treeState", "itemLimit", "itemClasses"])
                ]))
              : _createCommentVNode("", true)
          ], 42, ["onMousedown", "onDragstart"]),
          (_ctx.activeIndex != index && _ctx.activeIndex != index + 1 && _ctx.hasCapacity)
            ? (_openBlock(), _createBlock(_component_drag_zone, {
                key: 0,
                dragIndication: !!_ctx.treeState.dragElement,
                onDroped: $event => (_ctx.dragDrop(index + 1))
              }, null, 8, ["dragIndication", "onDroped"]))
            : _createCommentVNode("", true)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
})